import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, exhaustMap, map, of, switchMap, tap } from 'rxjs';

import { ProfessionalService } from 'src/app/shared/services/professional.service';
import { deleteProfessionalService, deleteProfessionalServiceError, deleteProfessionalServiceSuccess, editProfessionalService, editProfessionalServiceError, editProfessionalServiceSuccess, loadProfessionalService, loadProfessionalServiceByIdProfessional, loadProfessionalServiceSuccess, saveProfessionalService, saveProfessionalServiceError, saveProfessionalServiceSuccess } from './professional-service.actions';
import { ProfessionalServiceService } from 'src/app/shared/services/professional-service.service';
import { NotifyService } from 'src/app/shared/services/notify.service';

@Injectable()
export class ProfessionalServiceEffects {
  constructor(
    private service: ProfessionalServiceService,
    private action$: Actions,
    private notify: NotifyService
  ) {}

  loadProfessionalService$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadProfessionalService),
      exhaustMap(() =>
        this.service
          .getAll()
          .pipe(
            map((res) => loadProfessionalServiceSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );
  
  loadProfessionalServiceById$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadProfessionalServiceByIdProfessional),
      concatMap(({ professionalId }) =>
        this.service
          .getAllByProfessional(professionalId)
          .pipe(
            map((res) => loadProfessionalServiceSuccess({ lista: res })),
            catchError((error) => {
              this.notify.emitError('Falha ao carregar registros')
              return of(error.error['hydra:description'])
          })
          )
      )
    )
  );

  saveProfessionalService$ = createEffect(() =>
    this.action$.pipe(
      ofType(saveProfessionalService),
      concatMap(({ professionalService }) =>
        this.service.save(professionalService).pipe(
          tap(() => this.notify.saveSuccess()),
          map((res) => saveProfessionalServiceSuccess({professionalService: res})
          
            //[loadProfessionalServiceByIdProfessional({professionalId: (res as any).professional['@id']})]
        ),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(saveProfessionalServiceError());
          })
        )
      )
    )
  );

  editProfessionalService$ = createEffect(() =>
    this.action$.pipe(
      ofType(editProfessionalService),
      concatMap(({ professionalService, id }) =>
        this.service.edit(professionalService, id).pipe(
          tap(() => this.notify.editSuccess()),
          map((res) => editProfessionalServiceSuccess({professionalService: res})
          
           // [loadProfessionalServiceByIdProfessional({professionalId: (res as any).professional['@id']})]
        ),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(editProfessionalServiceError());
          })
        )
      )
    )
  );

  deleteProfessionalService$ = createEffect(() =>
    this.action$.pipe(
      ofType(deleteProfessionalService),
      concatMap(({ id, professionalId }) =>
        this.service.delete(id).pipe(
          tap(() => this.notify.deleteSuccess()),
          map((res) => deleteProfessionalServiceSuccess()
          
            //[loadProfessionalServiceByIdProfessional({professionalId: professionalId})]
        ),
          catchError((error) => {
            this.notify.emitError(error.error['hydra:description'])
            return of(deleteProfessionalServiceError());
          })
        )
      )
    )
  );
}
